// 时间戳格式化
export function parseTime(time, cFormat) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string')) {
			if ((/^[0-9]+$/.test(time))) {
				// support "1548221490638"
				time = parseInt(time)
			} else {
				// support safari
				// https://stackoverflow.com/questions/4310953/invalid-date-in-safari
				time = time.replace(new RegExp(/-/gm), '/')
			}
		}

		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
	return time_str
}
// 生成管理员的路由
export function createRoutes(asyncRoutes, data) {
	let routers = [];

	// for (var i = 0; i < asyncRoutes.length; i++) {
	// 	if(data.includes(asyncRoutes[i].path)){
	// 		routers[i] = asyncRoutes[i]

	// 	}
	// }
	asyncRoutes.forEach(item => {
		if (data.includes(item.path)) {
			let temp = item;
			temp.children2 = [];
			item.children.forEach(item2 => {
				if (data.includes(item2.path)) {
					temp.children2.push(item2);
				}
			})
			temp.children = temp.children2;
			delete temp.children2;
			routers.push(temp);
		}
	})
	return routers;
}

// 弹框
export function alertMsg(_this, msg, type_val = "error") {
	return _this.$message({
		showClose: true,
		message: msg,
		type: type_val
	});
}

// 获取接口地址
export function getBaseUrl() {
	let domain = window.location.host; // 获取当前域名
	console.log(domain)
	if(domain == 'whaleout.mini-jd.com'){
		return process.env.VUE_APP_ADMIN_BASE_URL2;
	}else{
		return process.env.VUE_APP_ADMIN_BASE_URL;
	}
}